import React from 'react';
import moment from 'moment';
import { getDollarFormat } from 'utils/helpers';
import NoDataMsg from 'library/noData';

const counter = 0;
const Body = ({ revenueReport, endDate, beginDate }) => (

    <div>
        {
            revenueReport.list && revenueReport.list.length <= 0 ?
                //If there's NO DATA to display
                <NoDataMsg />
                :
                revenueReport.list && revenueReport.list.length > 0 &&
                //If there's DATA
                <div>
                    <div className="row m-0 mb-1">
                        <div className="text-center list_header">
                            {beginDate ?
                                <p><i>From</i> <b>{moment(beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                                    {endDate ? <b>{moment(endDate).format('MMMM Do, YYYY')}</b> : moment().format('MMMM Do, YYYY')}</p>
                                : ""}
                        </div>
                    </div>
                    <div className="table-responsive">
                        <div className="row m-0 mb-2" >
                            <div className="col-lg-12 title_summary">
                                <h3 className="m-0 text-center text-justify">SUMMARY</h3>
                            </div>
                            <div className="col-lg-6 text-center border-right">
                                <label>Percentage of Overstocked Products</label>
                                <h3 className="m-0 purple-text size_1-2vmax ">{(revenueReport.overstock * 100).toFixed(2)}%</h3>
                            </div>
                            <div className="col-lg-6 text-center border-right">
                                <label>Percentage of Stocked Out Products</label>
                                <h3 className="m-0 purple-text size_1-2vmax ">{(revenueReport.understock * 100).toFixed(2)}%</h3>
                            </div>
                            <h3 className="m-0 text-center text-justify">Report</h3>
                        </div>
                        {
                            revenueReport && revenueReport.list.map((item, index) => {
                                return (

                                    <div className="row  mb-2 mt-2 border_bottom_grey" key={index}>
                                        <div className="col-lg-2 text-center border-right mb-1">
                                            <h4 className="m-0 blue-text  ">{item.pname}</h4>
                                            <h4 className="m-0 grey-text  ">SKU:</h4>
                                            <h5 className="m-0 grey-text  ">{item.sku}</h5>
                                            {item.iscannabis ? <h5 className="m-0 grey-text ">{item.cannabisclass}</h5> : <h5>Accessory</h5>}
                                        </div>
                                        <div className="col-lg-2 text-center  mb-1">
                                            <label>Opening Inventory</label>
                                            <h4 className="m-0 grey-text">{item.openinginventory}</h4>
                                            <label>Closing Inventory</label>
                                            <h4 className="m-0 grey-text">{item.openinginventory + item.quantityOrdered - item.qtySold}</h4>
                                        </div>
                                        <div className="col-lg-2 text-center border-right border-left mb-1">
                                            <label>Quantity Ordered</label>
                                            <h4 className="m-0 grey-text">{item.quantityOrdered}</h4>
                                            <label>Avg. Unit Cost</label>
                                            <h4 className="m-0 grey-text">{getDollarFormat(item.averageUnitCost)}</h4>
                                            <label>Total Cost</label>
                                            <h4 className="m-0 grey-text">{getDollarFormat(item.totalCost)}</h4>
                                        </div>
                                        <div className="col-lg-2 text-center  mb-1">
                                            <label>Quantity Sold</label>
                                            <h4 className="m-0 grey-text">{item.qtySold}</h4>
                                            <label>Unit Price</label>
                                            <h4 className="m-0 grey-text">{getDollarFormat(item.unitPrice)}</h4>
                                            <label>Actual Sales</label>
                                            <h4 className="m-0 grey-text">{getDollarFormat(item.actualSales)}</h4>
                                        </div>
                                        <div className="col-lg-2 text-center border-right border-left mb-1">
                                            <label>Revenue (Over/Under)</label>
                                            {item.overunder >= 0
                                                ?
                                                <h4 className="m-0 grey-text">{getDollarFormat(item.overunder)}</h4>
                                                :
                                                <h4 className="m-0 grey-text">({getDollarFormat(Math.abs(item.overunder))})</h4>
                                            }
                                            <label>Profit</label>
                                            <h4 className="m-0 grey-text">{getDollarFormat(item.profit)}</h4>
                                        </div>
                                        <div className="col-lg-2 text-center mb-1">
                                            {
                                                item.overunder >= 0 ?

                                                    <label style={overstock} className="text-center">
                                                        OVER STOCK
                                                    </label> :
                                                    <label style={stockedout} className="text-center">
                                                        STOCKED OUT
                                                    </label>

                                            }
                                        </div>
                                    </div>
                                );
                            })
                        }

                    </div>
                </div>
        }
    </div>
);

const stockedout = {
    color: 'white',
    backgroundColor: '#FF4C5B',
    fontSize: '20',
    height: 'auto',
    width: 'auto',
    fontHeight: 'auto'
}

const overstock = {
    color: '#FF4C5B',
    fontSize: '20',
    height: 'auto',
    width: 'auto',
    fontHeight: 'auto'
}

export default Body;